import React, { FC } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Routes } from 'src/routes';
import { routingOnRouteRequest } from 'src/app/store/routingSlice';
import { Box, Typography } from '@mui/material';
import PaperCard from 'src/components/PaperCard';
import InfoIcon from '@mui/icons-material/NotListedLocationOutlined';
import VideoPreview from 'src/components/VideoPreview';

type Props = ReturnType<typeof mapDispatchToProps>;

const ReceiptsAbout: FC<Props> = ({ goTo }) => {
  return (
    <PaperCard sx={{ pl: ({ spacing }) => spacing(6) }}>
      <Box display="flex" gap={1}>
        <InfoIcon
          sx={{
            width: ({ spacing }) => spacing(5),
            height: ({ spacing }) => spacing(5),
          }}
        />
        <Box display="flex" gap={4} alignItems="center">
          <Box
            display="flex"
            flexDirection="column"
            sx={{ userSelect: 'none' }}
          >
            <Typography
              variant="h6"
              fontSize={17}
              fontWeight={500}
              letterSpacing={-0.5}
            >
              למד על עמוד זה
            </Typography>
            <Typography variant="body1" fontSize={15} letterSpacing={-0.5}>
              העמוד <strong>{'החשבוניות שלי'}</strong> מהווה מרכז ניהול וארגון
              לכל החשבוניות שלך.
              <br /> המערכת מציעה מגוון אפשרויות סינון מתקדמות, כך שתוכל למצוא
              בקלות חשבוניות לפי מצבן (למשל, שולמו, לא שולמו), לפי תאריך, או
              אפילו לפי מקור המסמך. בנוסף, המערכת מאפשרת לך לקבל תצוגה מפורטת של
              כל חשבונית, לערוך פרטים כלשהם, לייצא נתונים לצורכי ניתוח או דיווח,
              ואף לסנכרן חשבוניות שנשלחו אליך באימייל ישירות למערכת.
            </Typography>
          </Box>
          <VideoPreview />
        </Box>
      </Box>
    </PaperCard>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  goTo: (path: Routes) => dispatch(routingOnRouteRequest({ path })),
});

export default connect(null, mapDispatchToProps)(ReceiptsAbout);
